import { render, staticRenderFns } from "./WizardUpload.vue?vue&type=template&id=24228cda&"
import script from "./WizardUpload.vue?vue&type=script&lang=js&"
export * from "./WizardUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports